/**
 * Environment access, validated once at module load.
 *
 * Only the anon key ever reaches the client. The `service_role` key must never
 * appear in this file, in `.env`, or anywhere under `src/` — it bypasses RLS, and
 * the whole authorization model in docs/01-architecture.md depends on it staying
 * server-side.
 */

type EnvKey = 'VITE_SUPABASE_URL' | 'VITE_SUPABASE_ANON_KEY';

// Vite's ImportMetaEnv carries a `[key: string]: any` index signature, so the read
// is deliberately narrowed through `unknown` rather than trusted.
function required(name: EnvKey): string {
  const value: unknown = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Missing environment variable ${name}. Copy .env.example to .env and fill it in.`,
    );
  }
  return value;
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY'),
} as const;
